// extracted by mini-css-extract-plugin
module.exports = {"jewellery":"SellYourJewellery_jewellery__LLUrD","button_container":"SellYourJewellery_button_container__fyeH9"};